"use client";

import { useSyncExternalStore } from "react";

const MOBILE_BREAKPOINT = 768;

// Server snapshot - always returns false to avoid hydration mismatch
function getServerSnapshot(): boolean {
  return false;
}

// Client snapshot - returns actual mobile state
function getSnapshot(): boolean {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

// Subscribe to window resize events
function subscribe(callback: () => void): () => void {
  const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
  mql.addEventListener("change", callback);
  window.addEventListener("resize", callback);
  return () => {
    mql.removeEventListener("change", callback);
    window.removeEventListener("resize", callback);
  };
}

/**
 * Hook to detect if the viewport is mobile-sized.
 * Uses useSyncExternalStore for proper SSR hydration.
 */
function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export { useIsMobile };
